import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite'
import { useQuery } from 'react-query'
import { Spinner } from '@blueprintjs/core'
import VirtualList from 'components/VirtualList'
import User from 'pages/User'
import SocketStore from 'stores/socketStore'
import WSChannelsNames from 'constants/WSChannelsNames'
import { socketConnection } from 'tools/socketManager';
import { ON_NAV_OBJECT_ADDED, ON_NAV_OBJECT_CHANGED, ON_NAV_OBJECT_REMOVED } from 'constants/socketManager';
import { addPanel } from 'tools/initGoldenLayout'
import { getUsers } from 'api/usersService'
import { Styled } from '../LeftPanel.styled'

const UsersList = observer(() => {
    const [selectedObjectIds, setSelectedObjectIds] = useState([])

    const { data, isLoading, error, refetch } = useQuery("usersListForObjectsObserver", () => getUsers())

    const updatedItem = SocketStore.getChannelData(ON_NAV_OBJECT_CHANGED, WSChannelsNames.User);
    const removedItem = SocketStore.getChannelData(ON_NAV_OBJECT_REMOVED, WSChannelsNames.User);
    const addedItem = SocketStore.getChannelData(ON_NAV_OBJECT_ADDED, WSChannelsNames.User);

    useEffect(() => {
        if (!socketConnection) return

        SocketStore.addSocketChannel(ON_NAV_OBJECT_CHANGED, WSChannelsNames.User, '')
        SocketStore.addSocketChannel(ON_NAV_OBJECT_REMOVED, WSChannelsNames.User, '')
        SocketStore.addSocketChannel(ON_NAV_OBJECT_ADDED, WSChannelsNames.User, '')

        return () => {
            SocketStore.removeSocketChannel(ON_NAV_OBJECT_CHANGED, WSChannelsNames.User, '')
            SocketStore.removeSocketChannel(ON_NAV_OBJECT_REMOVED, WSChannelsNames.User, '')
            SocketStore.removeSocketChannel(ON_NAV_OBJECT_ADDED, WSChannelsNames.User, '')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socketConnection]);


    useEffect(() => {
        refetch()
    }, [refetch, removedItem, updatedItem, addedItem])

    return (
        <Styled.ListContainer>
            {isLoading ? (
                <Spinner />
            ) : error ? (
                <p>Произошла ошибка, попробуйте перезагрузить страницу</p>
            ) : (
                <VirtualList
                    list={data?.map(item => ({ objectId: item.id, ...item }))}
                    needSelectObj={false}
                    rowCount={data.length}
                    onRowDblClick={({ objectId }) => addPanel('Свойства пользователя', User, false, { id: objectId })}
                    selectedObjectIds={selectedObjectIds}
                    setSelectedObjectIds={setSelectedObjectIds}
                    searchedObjectIndex={null}
                />
            )}
        </Styled.ListContainer>
    );
})

export default UsersList;
